<script setup lang="ts">
import ModalFromBot from "@/components/Modal/ModalFromBot.vue";
import { List, Tab, Tabs } from "vant";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import WaterFallList from "../components/WaterFallList.vue";
import _service from "@/service";
const route = useRoute();
const isShow = ref(false);
const listLoading = ref(false);
const listFinished = ref(false);
const productList = ref<any>([]);
const activeTabIndex = ref(0);
const pageNo = ref(1);
const activeSortValue = ref("默认排序");
const params = route.params.coupon;
const tabList = [
  {
    label: "好物甄选",
    value: "1",
  },
//   {
//     label: "消费券",
//     value: "2",
//   },
];
const sortList = [
  {
    label: "默认排序",
    value: "1",
  },
  {
    label: "积分由低到高",
    value: "2",
  },
  {
    label: "积分由高到低",
    value: "3",
  },
];

const getProductList = async () =>{
  if (listFinished.value) {
    return false
  }
  listLoading.value = true
  const {data} = await _service.getProductByCategoryId({
    pageNo:pageNo.value,
    pageSize:20,
    saleLocation:1
  })
  listLoading.value = false
  productList.value = productList.value.concat(data.list)
  if (productList.value.length >= data.total) {
    listFinished.value = true
    return false
  }
  pageNo.value = pageNo.value + 1
}

const resetList = () => {
  productList.value = []
  pageNo.value = 1
  listFinished.value = false
}

const onLoad = ()=>{
    getProductList()
}

const changeSort = (item: any) => {
  activeSortValue.value = item.label;
  isShow.value = false;
};


watch(
  () => {
    params;
  },
  () => {
    activeTabIndex.value = 1;
  }
);
</script>

<template>
  <div class="layout">
    <div>
      <Tabs v-model:active="activeTabIndex" sticky swipeable>
        <Tab :title="item.label" v-for="item in tabList" :key="item.label">
          <div class="sort flex-row-start-center" @click="isShow = true">
            {{ activeSortValue }}
            <i class="sortdown"  />
          </div>
          <div class="list-wrapper">
            <List 
              v-model:loading="listLoading"
              :finished="listFinished"
              @load="onLoad"
              offset="500"
            >
            <div class="no-data" v-if="listFinished && !productList.length">暂无数据</div>
                <WaterFallList :data="productList"></WaterFallList>
            </List>
          </div>
        </Tab>
      </Tabs>
    </div>
    <ModalFromBot v-model:is-show="isShow" title="排序" class="contentclass">
      <div class="sortlist">
        <div
          class="item"
          @click="changeSort(item)"
          v-for="(item, index) in sortList"
          :key="index"
        >
          {{ item.label }}
          <i class="checkedIcon" v-if="activeSortValue === item.label" />
        </div>
      </div>
    </ModalFromBot>
  </div>
</template>

<style lang="scss" scoped>
.layout {
  // padding: 0 12px;
  overflow-y: hidden;
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  :deep(.van-tabs__nav) {
    display: flex;
    justify-content: flex-start;
    gap: 30px;
    padding: 0 12px;
    background: transparent;
    .van-tab {
      flex: unset;
      color: #9c9caa;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .van-tab--active {
      color: #1cf2e4;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
    }
    .van-tabs__line {
      width: 28px;
      bottom: 3px;
      height: 7px;
      background: url(../../../assets/integral/activeTab.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .tablayout {
    padding: 0 12px;
  }
  .sort {
    color: $text2;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    gap: 2px;
    margin: 8px 0;
    padding: 0 12px;
    .sortdown{
        width: 16px;
        height: 16px;
        background: url(../../../assets/integral/sortdown.svg);
        background-size: contain;
        background-repeat: no-repeat;
    }
  }
  .content {
    height: calc(100vh - 74px);
    padding-bottom: 10px;
  }
}

.list-wrapper{
    height: calc(100vh - 85px);
    overflow-y: scroll;
    padding: 0 12px;
}

.sortlist {
    width: 100%;
    margin-bottom: 20px;
    margin-top: 8px;
    .item {
      font-size: 16px;
      font-weight: 500;
      color: $text1;
      height: 52px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 24px;
      width: 100%;
      .checkedIcon{
        width: 16px;
        height: 16px;
        background: url(../../../assets/check.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .active {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
